export default "__VITE_ASSET__7772f6e8__"